import { colorTokens, textTokens } from "../../styles/globalStyles";

export const statsChartTooltipStyles = {
  backgroundColor: colorTokens.bg.surfaceElevated,
  border: `1px solid ${colorTokens.border.default}`,
  borderRadius: 8,
  color: colorTokens.text.primary,
  fontFamily: textTokens.fontFamily,
  fontSize: 13,
};

export const statsChartTooltipLabelStyles = {
  color: colorTokens.text.title,
  fontWeight: 600,
  marginBottom: 4,
};

export const statsChartAxisTick = {
  fill: colorTokens.text.muted,
  fontSize: 11,
  fontFamily: textTokens.fontFamily,
};
